import { Box } from '@mui/material';

interface CalendlyLogoProps {
    readonly altText?: string;
    readonly height?: string | number;
    readonly width?: string | number;
}

function TelegramLogo({ altText = 'Telegram Logo', height = 30, width = 30 }: Readonly<CalendlyLogoProps>) {
    const basePath = process.env.EXPO_PUBLIC_IMAGE_SERVE_HOST;

    return (
        <Box
            alt={altText}
            component="img"
            src={`${basePath!}/logos/telegram_logo.png`}
            sx={{
                height,
                objectFit: 'contain',
                width,
            }}
        />
    );
}

export default TelegramLogo;
